import { JSX, useContext } from "react";
import { NetworkIntegrityAggregateTableRow } from "@app/projects/network-assessment/network-integrity/models";
import { NetworkIntegrityContext } from "@app/projects/network-assessment/network-integrity/NetworkIntegrityContext";
import { NetworkIntegrityDisplayMode } from "@app/projects/network-assessment/network-integrity/filters/networkIntegrityFilterConstants";
import { NetworkIntegrityChangeArrow } from "@app/projects/network-assessment/network-integrity/widgets/NetworkIntegrityChangeArrow";

interface NetworkIntegrityAggregateTableProps {
  aggregateHeader: string;
  aggregateCountHeader: string;
  rows: NetworkIntegrityAggregateTableRow[];
};

const NetworkIntegrityAggregateTable = (props: NetworkIntegrityAggregateTableProps): JSX.Element => {
  const networkIntegrityContext = useContext(NetworkIntegrityContext);

  const showTotalAfterTermed = networkIntegrityContext.displayMode === NetworkIntegrityDisplayMode.TotalAfterTermed;

  const rows = props.rows?.map(({ afterTermedCount, aggregateKey, aggregateKeyClassName, count, rawAfterTermedCount, rawCount }) => {
    let countCell: JSX.Element;

    if (showTotalAfterTermed) {
      const hasDecrease = rawAfterTermedCount != null && rawCount != null && rawAfterTermedCount < rawCount;
      if (hasDecrease) {
        const decrease = rawCount - rawAfterTermedCount;
        countCell = (
          <>
            {afterTermedCount ?? count ?? <span>---</span>}
            <span className="ni-table__decrease-indicator">
              <NetworkIntegrityChangeArrow direction="decrease" />
              {"("}{decrease.toLocaleString()}{")"}
            </span>
          </>
        );
      } else {
        countCell = count ?? <span>---</span>;
      }
    } else {
      countCell = count ?? <span>---</span>;
    }

    return (
      <tr key={`network-integrity-aggregate-${aggregateKey}`}>
        <td><span className={aggregateKeyClassName}>{aggregateKey}</span></td>
        <td>{countCell}</td>
      </tr>
    )
  }
  );

  return (
    <div className="d-flex flex-column align-items-center ni-table-container">
      <table className="ni-table">
        <thead>
          <tr>
            <th>{props.aggregateHeader}</th>
            <th>{props.aggregateCountHeader}</th>
          </tr>
        </thead>
        <tbody>
          {rows}
        </tbody>
      </table>
    </div>
  );
}

export { NetworkIntegrityAggregateTable };